import useMousePosition from '@/hooks/useMousePosition';
import { twMerge } from 'tailwind-merge';

const MapTooltip = ({
  title,
  className,
  offset,
}: {
  title: string;
  className?: string;
  offset?: { x: number; y: number };
}) => {
  const { x, y } = useMousePosition();

  if (!title || !x || !y) return null;

  return (
    <div
      data-testid="map-tooltip"
      className={twMerge(
        'fixed bg-textDarkGrey/75 text-white rounded-sm whitespace-normal font-bold max-w-[250px] text-xs p-2 z-tooltip pointer-events-none',
        className
      )}
      style={{
        left: `${x + (offset?.x ?? 0)}px`,
        top: `${y + (offset?.y ?? 0)}px`,
      }}
    >
      <p>{title}</p>
    </div>
  );
};

export default MapTooltip;
